<section class="ddc-billing-container">
  <div class="ddc-billing-header">
    <ddc-pricing-plan [infoOnly]="true" [plan]="$any(selectedPlan.toLowerCase())"></ddc-pricing-plan>
  </div>
  @if (this.subscription_plan === 'Plus') {
    <ddc-text-gradient
      [_text]="'You are currently on the default plan. Enjoy the road ahead !'"
      [_type]="'2'"
    ></ddc-text-gradient>
  } @else {
    <ng-template #billingCard></ng-template>
    <div class="modern-card billing-details">
      <div class="subscription-info">
        <h2 class="plan-title" style="display: flex; gap: 5px">
          <span> Yearly Subscription Plan: </span>

          <ddc-text-gradient
            [_text]="selectedPlan | titlecase"
            [_type]="selectedPlan === 'Plus' ? '2' : '1'"
          ></ddc-text-gradient>
        </h2>
        <div class="date-info">
          <span class="date-label">Start Date:</span>
          <span class="date-value">{{ startDate | date: 'longDate' }}</span>
        </div>
        <div class="date-info">
          <span class="date-label">End Date:</span>
          <span class="date-value">{{ endDate | date: 'longDate' }}</span>
        </div>
        <div class="date-info">
          <span class="date-label">Price:</span>
          <span class="date-value"
            ><span style="font-weight: bold">€{{ currentPrice }}</span>
          </span>
          <span style="color: gray">(approximately €{{ currentMonthlyPrice }}/month)</span>
        </div>
      </div>

      <div class="terms-check">
        <label class="checkbox-container">
          <input id="termsCheckbox" type="checkbox" [(ngModel)]="agreedToTerms" />
          <span class="checkmark"></span>
          <span class="checkbox-label-text">
            I agree to the <a href="/termsandconditions" style="margin-left: 4px">terms and conditions</a>
          </span>
        </label>
      </div>

      <div class="paypal-section" *ngIf="agreedToTerms">
        <mat-divider class="divider" style="margin-bottom: 20px"></mat-divider>
        <h2 class="plan-title">Paypal Payment</h2>
        <div id="paypal-button-container"></div>
      </div>
    </div>
  }
</section>
